var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29048",
    "data-name": "Group 29048",
    transform: "translate(-1280 -674)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21068",
    "data-name": "Rectangle 21068",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(1280 674)",
    fill: "rgba(6,35,61,0.14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_",
    transform: "translate(1288.757 681.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    d: "M9.258,107.963,6.626,110.6h0a2.791,2.791,0,0,1-3.948-3.948h0l2.632-2.632A.93.93,0,0,0,3.994,102.7l-2.632,2.632h0a4.652,4.652,0,0,0,6.58,6.579h0l2.632-2.632a.93.93,0,0,0-1.316-1.316Z",
    transform: "translate(0 -96.04)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    d: "M113.271,4.686a4.652,4.652,0,0,0-7.942-3.29h0L102.7,4.028a.93.93,0,1,0,1.316,1.316l2.632-2.632h0a2.791,2.791,0,0,1,3.948,3.948h0l-2.632,2.632a.93.93,0,1,0,1.316,1.316l2.632-2.632h0A4.622,4.622,0,0,0,113.271,4.686Z",
    transform: "translate(-96.071 0)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    d: "M81.486,88.065a.93.93,0,0,0,1.316,0L88.065,82.8a.93.93,0,0,0-1.316-1.316l-5.264,5.264A.931.931,0,0,0,81.486,88.065Z",
    transform: "translate(-76.176 -76.142)",
    fill: "#06233d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.31d030ae22ba0914697b01d607e81746.svg";
export { ForwardRef as ReactComponent };